export const assignSequenceIds = (nodes = []) => {
    let contentSequence = 0;
    let secondarySequence = 0;

    return nodes.map((node) => {
        let sequenceId;

        if (node.type === 'content') {
            contentSequence += 1;
            secondarySequence = 0;

            sequenceId = String(contentSequence);
        } else {
            secondarySequence += 1;

            sequenceId = `${contentSequence}.${secondarySequence}`;
        }

        return {
            ...node,
            sequence_id: sequenceId,
        };
    });
};